var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"dense":"","outlined":"","filled":_vm.readonly,"readonly":_vm.readonly},on:{"change":_vm.onInput},model:{value:(_vm.item),callback:function ($$v) {_vm.item=_vm._n($$v)},expression:"item"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }